// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GMP0","content":"styles_content__3wkpP"};